import React from 'react';
import PropTypes from 'prop-types';
import { graphql, Link } from 'gatsby';
import Layout from '../components/Layout';
import PreviewCompatibleImage from '../components/PreviewCompatibleImage';
import { ContactForm } from '../views/contact-form';
import { HTMLContent } from '../components/Content';

export const WorkshopPageTemplate = ({ title, image, html }) => (
  <section className="section section--gradient">
    <div className="container">
      <h4 className="title is-4 has-text-centered">
        <Link to="/workshops">← Мастер-классы</Link>
      </h4>
      <div className="content">
        <div className="columns">
          <div className="column">
            <PreviewCompatibleImage imageInfo={image} style={{ maxHeight: '600px' }} />
          </div>
          <div className="column">
            <h1 className="title is-1">{title}</h1>
            <HTMLContent className="content" content={html} />
          </div>
        </div>
        <hr />
        <div className="columns">
          <div className="column is-half is-offset-one-quarter">
            <h2 className="has-text-centered">Оставить заявку</h2>
            <ContactForm purpose={`Мастер-класс "${title}"`} />
          </div>
        </div>
      </div>
    </div>
  </section>
);

WorkshopPageTemplate.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

const WorkshopPage = ({ data }) => {
  const { frontmatter, html } = data.markdownRemark;

  return (
    <Layout title={frontmatter.title}>
      <WorkshopPageTemplate {...frontmatter} html={html} />
    </Layout>
  );
};

WorkshopPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    }),
  }),
};

export default WorkshopPage;

export const workshopPageQuery = graphql`
  query WorkshopPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
        description
        price
        image {
          childImageSharp {
            fluid(maxWidth: 1280, quality: 65) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`;
